var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.toeic || !!_vm.toefl || _vm.isSetLanguageSkill,
        label: "語学力",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "boss-layout boss-layout-start boss-layout-wrap boss-layout-gap-large",
        },
        [
          _c("div", [
            _vm._v("\n      TOEIC：\n      "),
            _c("input", {
              staticClass: "boss-input",
              staticStyle: { width: "6em" },
              attrs: {
                type: "number",
                "data-test": "toeic",
                max: "990",
                min: "0",
              },
              domProps: { value: _vm.toeic },
              on: {
                change: function ($event) {
                  _vm.$emit("update:toeic", Number($event.target.value) || null)
                },
                keypress: function ($event) {
                  return _vm.onlyNumberInRange($event, 990)
                },
              },
            }),
            _vm._v("点以上\n    "),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n      TOEFL：\n      "),
            _c("input", {
              staticClass: "boss-input",
              staticStyle: { width: "6em" },
              attrs: {
                type: "number",
                "data-test": "toefl",
                max: "677",
                min: "0",
              },
              domProps: { value: _vm.toefl },
              on: {
                change: function ($event) {
                  _vm.$emit("update:toefl", Number($event.target.value) || null)
                },
                keypress: function ($event) {
                  return _vm.onlyNumberInRange($event, 677)
                },
              },
            }),
            _vm._v("点以上\n    "),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n      英語スキル：\n      "),
            _c(
              "select",
              {
                staticClass: "boss-input-select",
                domProps: { value: _vm.englishSkill.level },
                on: {
                  change: function ($event) {
                    return _vm.updateEnglishLevel($event.target.value)
                  },
                },
              },
              [
                _c(
                  "option",
                  { attrs: { value: "", "data-test": "english-none" } },
                  [_vm._v("\n          指定なし\n        ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.languageSkillsMaster, function (option, i) {
                  return _c(
                    "option",
                    {
                      key: i,
                      attrs: { "data-test": "english-" + option.id },
                      domProps: { value: option.id },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(option.name) + "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("span", [_vm._v("以上")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm._l(
        _vm.languageSkillsWithoutEnglishForDisp,
        function (languageSkill, i) {
          return _c("div", { key: i, staticClass: "pega-label-indent" }, [
            i === 0
              ? _c(
                  "span",
                  {
                    staticClass: "indented-label",
                    attrs: { "data-test": "label-" + i },
                  },
                  [_vm._v("\n      英語以外の語学スキル：\n    ")]
                )
              : _c("span", {
                  staticClass: "white-space-label",
                  attrs: { "data-test": "label-" + i },
                }),
            _vm._v(" "),
            _c(
              "select",
              {
                staticClass: "boss-input-select",
                attrs: { "data-test": "language-" + i },
                domProps: { value: languageSkill.id },
                on: {
                  change: function ($event) {
                    return _vm.updateOtherLanguage(
                      {
                        id: $event.target.value || "",
                        level: languageSkill.level,
                      },
                      i
                    )
                  },
                },
              },
              [
                _c(
                  "option",
                  {
                    attrs: {
                      value: "",
                      "data-test": "language-" + i + "-none",
                    },
                  },
                  [_vm._v("\n        指定なし\n      ")]
                ),
                _vm._v(" "),
                _vm._l(_vm.languagesMasterWithoutEnglish, function (option, j) {
                  return [
                    option.id === Number(languageSkill.id) ||
                    !_vm.selectedLanguageIds.includes(option.id)
                      ? _c(
                          "option",
                          {
                            key: "language-" + i + "-" + j,
                            attrs: {
                              "data-test": "language-" + i + "-" + option.id,
                            },
                            domProps: { value: option.id },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(option.name) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                staticClass: "boss-input-select",
                attrs: {
                  disabled: !languageSkill.id,
                  "data-test": "language-level-" + i,
                },
                domProps: { value: languageSkill.level },
                on: {
                  change: function ($event) {
                    return _vm.updateOtherLanguage(
                      { id: languageSkill.id, level: $event.target.value },
                      i
                    )
                  },
                },
              },
              _vm._l(_vm.languageSkillsMaster, function (option, j) {
                return _c(
                  "option",
                  {
                    key: "language-level-" + i + "-" + j,
                    attrs: {
                      "data-test": "language-level-" + i + "-" + option.id,
                    },
                    domProps: { value: option.id },
                  },
                  [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", [_vm._v("以上")]),
          ])
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }